'use client';

import { FC, useEffect } from 'react';

import sentryService from '@/services/sentry/sentry.service';

// see https://nextjs.org/docs/app/building-your-application/routing/error-handling#recovering-from-errors
interface Props {
  error: Error & { digest?: string };
}

const Error: FC<Props> = ({ error }) => {
  useEffect(() => {
    sentryService.captureException(error);
  }, [error]);

  const reset = async  () => {
    await sentryService.flush();
    window.location.reload();
  }

  return (
    <div>
      <h2>Something went wrong!</h2>
      <button onClick={() => reset()}>Try again</button>
    </div>
  );
};

export default Error;